import styles from './Spinner.module.scss';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

export function Spinner({ size = 'md', color }: SpinnerProps): React.JSX.Element {
  return (
    <div
      className={`${styles.spinner} ${styles[`spinner--${size}`]}`}
      style={{ borderColor: color ? `${color}33` : undefined, borderTopColor: color }}
    />
  );
}
